export default {"src":"/_next/static/media/mohegansun-logo.4a0804e1.svg","height":32,"width":129,"blurWidth":0,"blurHeight":0};